import Swiper from 'swiper';
import {
  Autoplay,
  FreeMode,
  Navigation,
  Pagination,
  Thumbs,
  Mousewheel,
} from 'swiper/modules';

Swiper.use([Autoplay, FreeMode, Navigation, Pagination, Thumbs, Mousewheel]);

const InitSwiper = () => {
  const swiperMarquee = document.querySelector(
    '[data-component="swiper-marquee"]'
  );

  if (swiperMarquee) {
    let upEvenPhase = true; // true면 짝수 index가 UP, false면 홀수가 UP

    const applyUpDownPhase = (sw) => {
      sw.slides.forEach((slide) => {
        const i = parseInt(slide.dataset.swiperSlideIndex, 10);
        if (Number.isNaN(i)) return;

        // 원본 인덱스의 짝/홀 그룹
        const isEven = i % 2 === 0;

        // 현재 페이즈에 따라 up/down 결정
        const makeUp = upEvenPhase ? isEven : !isEven;

        slide.classList.toggle('is-up', makeUp);
        slide.classList.toggle('is-down', !makeUp);
      });
    };

    const swiper = new Swiper(swiperMarquee, {
      modules: [Autoplay],
      loop: true,
      slidesPerView: 1.8,
      spaceBetween: 10,
      centeredSlides: true,
      speed: 3000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      allowTouchMove: false, // 터치/마우스 드래그 스와이프 비활성
      simulateTouch: false, // 데스크톱에서 마우스 드래그 시뮬레이트 끔
      followFinger: false, // 손가락 따라가기 끔(안전장치)
      touchRatio: 0, // 터치 이동 비율 0
      mousewheel: false, // mousewheel 모듈 안 쓰게
      keyboard: { enabled: false },
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 5.8,
          spaceBetween: 20,
        },
      },
      on: {
        init() {
          applyUpDownPhase(this); // 초기 1회 적용
        },
        slideChangeTransitionStart() {
          upEvenPhase = !upEvenPhase; // 페이즈 토글
          applyUpDownPhase(this); // 매 이동 후 재적용
        },
        // 필요 시 resize에도 유지
        resize() {
          applyUpDownPhase(this);
        },
      },
    });
  }

  const swiperGalleries = document.querySelector(
    '[data-component="swiper-gallery"]'
  );
  if (swiperGalleries) {
    swiperGalleries.__thumbs?.destroy(true, true);
    swiperGalleries.__main?.destroy(true, true);

    const galleryThumbs = new Swiper(
      swiperGalleries.querySelector('.gallery-thumbs'),
      {
        modules: [Mousewheel],
        direction: 'vertical',
        spaceBetween: 15,
        slidesPerView: 4,
        watchSlidesProgress: true,
        mousewheel: true,
        // slideToClickedSlide: true,
        // centeredSlides: true,
        // freeMode: true,
        observer: true,
        observeParents: true,
      }
    );
    galleryThumbs.slides.forEach((slide, index) => {
      slide.addEventListener('mouseenter', () => {
        gallerySlider.slideTo(index);
        galleryThumbs.slideTo(index);
      });
    });
    const gallerySlider = new Swiper(
      swiperGalleries.querySelector('.gallery-slider'),
      {
        // modules: [Navigation, Thumbs],
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: swiperGalleries.querySelector('.swiper-button-next'),
          prevEl: swiperGalleries.querySelector('.swiper-button-prev'),
          uniqueNavElements: true,
        },
        thumbs: {
          swiper: galleryThumbs,
        },
      }
    );
  }
  const swiperHero = document.querySelector('[data-component="swiper-hero"]');
  if (swiperHero) {
    const heroSwiper = new Swiper(swiperHero, {
      modules: [Pagination, Autoplay, Navigation],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 800,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      navigation: {
        nextEl: swiperHero.querySelector('.swiper-button-next'),
        prevEl: swiperHero.querySelector('.swiper-button-prev'),
        uniqueNavElements: true,
      },
      pagination: {
        el: swiperHero.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  }
};

export default InitSwiper;
